import { render, staticRenderFns } from "./BsCard.vue?vue&type=template&id=1632c01a&"
import script from "./BsCard.vue?vue&type=script&lang=js&"
export * from "./BsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports